import { type FormEvent, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api } from '../lib/api';
import { ErrorNotice } from '../components/ui';

/** Wireframe B1 — sign-up needs only business details and an email (FR-B1). */
export function SignUp() {
  const navigate = useNavigate();
  const [businessName, setBusinessName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.signUp({ email, businessName, password: password || undefined });
      navigate('/devices', { replace: true });
    } catch (caught) {
      setError(caught);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth">
      <div className="card">
        <div className="card-body">
          <h1>Create your account</h1>
          <p className="sub">Register your NeteGate devices and manage guest WiFi.</p>
          <ErrorNotice error={error} />
          <form onSubmit={submit}>
            <div className="field">
              <label htmlFor="business">Business name</label>
              <input id="business" value={businessName} onChange={(e) => setBusinessName(e.target.value)} required minLength={2} />
            </div>
            <div className="field">
              <label htmlFor="email">Email address</label>
              <input id="email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                autoComplete="new-password"
                minLength={10}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className="hint">Optional — leave blank to sign in with an emailed code instead.</div>
            </div>
            <button type="submit" disabled={busy}>
              {busy ? 'Creating account…' : 'Create account'}
            </button>
          </form>
          <div className="alt">
            Already registered? <Link to="/signin">Sign in</Link>
          </div>
        </div>
      </div>
      <div className="qubow-footer muted" style={{ fontSize: '12px', textAlign: 'center', marginTop: '20px', width: '100%' }}>
        © 2026 Developed by <b><a href="https://www.qubow.com" target="_blank" aria-label="Qubow" style={{ color: 'inherit', textDecoration: 'none' }}>Qubow</a></b>
      </div>
    </div>
  );
}
